import { render, staticRenderFns } from "./OsParticipantCustomFieldAnswersForm.vue?vue&type=template&id=37fabf6a&scoped=true"
import script from "./OsParticipantCustomFieldAnswersForm.vue?vue&type=script&lang=ts"
export * from "./OsParticipantCustomFieldAnswersForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fabf6a",
  null
  
)

export default component.exports